"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountType = void 0;
var AccountType;
(function (AccountType) {
    AccountType["Single"] = "Single";
    AccountType["Group"] = "Group";
    AccountType["NotSelected"] = "NotSelected";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
//# sourceMappingURL=account-type.js.map